import { useSyncExternalStore } from 'react'

/**
 * Subscribes to a CSS media query and re-renders when it changes.
 * SSR-safe (returns false on the server, though this app is client-only).
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onStoreChange) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onStoreChange)
      return () => mql.removeEventListener('change', onStoreChange)
    },
    () => window.matchMedia(query).matches,
    () => false
  )
}

/** True below Tailwind's `md` breakpoint (768px) — the app's mobile layout switch. */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)')
}
